import { render, staticRenderFns } from "./FormSetHotspot.vue?vue&type=template&id=7fb245c5"
import script from "./FormSetHotspot.vue?vue&type=script&lang=js"
export * from "./FormSetHotspot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports